// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tkfq","textarea":"styles_textarea__1x0MB"};